import React from "react";
import { Text, Icon } from "shared";
import { getDate } from "utils/time";
import { useTranslation } from "react-i18next";
import { Circle } from "assets";

interface ActiveProps {
  user: {
    created_at: string;
    id: number;
  };
}

const Active: React.VFC<ActiveProps> = ({ user }) => {
  const { t } = useTranslation();

  if (!user) return null;

  return (
    <Text paragraph mb={0} data-testid="status">
      <Icon of={Circle} success size={0.7} aria-label="Active account" />
      <Text ml={1} bold>
        {user.id}
      </Text>
      <Text right>
        <Text light>{t`patients.created`}: </Text>
        <Text bold>{user.created_at && getDate(user.created_at)}</Text>
      </Text>
    </Text>
  );
};

export default Active;
